var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33325 1.33264C5.33325 0.598808 5.93022 0 6.66044 0H9.3394C10.0742 0 10.6666 0.595391 10.6666 1.33264V2.0007C10.6666 2.73453 10.0696 3.33333 9.3394 3.33333H6.66044C5.92565 3.33333 5.33325 2.73794 5.33325 2.0007V1.33264ZM6.66044 1.33333C6.66662 1.33318 6.66659 2 6.66659 2H9.3394C9.33453 2 9.33325 1.33333 9.33325 1.33333H6.66044Z",
    fill: "#676A7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2V13.3333C14 14.8086 12.8079 16 11.327 16H4.67299C3.19579 16 2 14.8099 2 13.3333V2H14ZM3.33333 13.3333C3.33333 14.0721 3.93075 14.6667 4.67299 14.6667H11.327C12.0717 14.6667 12.6667 14.0721 12.6667 13.3333V3.33333H3.33333V13.3333Z",
    fill: "#676A7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55551 5.77778V12.2222C5.55551 12.5904 5.85399 12.8889 6.22218 12.8889C6.59037 12.8889 6.88885 12.5904 6.88885 12.2222V5.77778C6.88885 5.40959 6.59037 5.11111 6.22218 5.11111C5.85399 5.11111 5.55551 5.40959 5.55551 5.77778ZM9.11107 5.77778V12.2222C9.11107 12.5904 9.40955 12.8889 9.77774 12.8889C10.1459 12.8889 10.4444 12.5904 10.4444 12.2222V5.77778C10.4444 5.40959 10.1459 5.11111 9.77774 5.11111C9.40955 5.11111 9.11107 5.40959 9.11107 5.77778ZM1.33329 3.33333H14.6666C15.0348 3.33333 15.3333 3.03486 15.3333 2.66667C15.3333 2.29848 15.0348 2 14.6666 2H1.33329C0.965103 2 0.666626 2.29848 0.666626 2.66667C0.666626 3.03486 0.965103 3.33333 1.33329 3.33333Z",
    fill: "#676A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trash_bin.d55c1e38dd948f6c753b77aa96e1a0ca.svg";
export { ForwardRef as ReactComponent };